var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.259,
    height: 9.804,
    viewBox: "0 0 16.259 9.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cow-solid",
    d: "M2.451,68.085v4.9a.816.816,0,0,0,.817.817h.817a.816.816,0,0,0,.817-.817V70.735a3.77,3.77,0,0,0,.817.411v.615a.409.409,0,0,0,.817,0V71.33a3.644,3.644,0,0,0,.817,0v.431a.409.409,0,0,0,.817,0v-.618a3.553,3.553,0,0,0,.817-.411v2.254A.816.816,0,0,0,9.8,73.8h.817a.816.816,0,0,0,.817-.817V68.9l.817.817v1.264a1.215,1.215,0,0,0,.207.679l1.07,1.606a1.206,1.206,0,0,0,2.185-.434l.518-2.594a1.226,1.226,0,0,0-.2-.952l-.1-.14V67.064a.613.613,0,1,0-1.226,0v.368L13.356,65.54A3.683,3.683,0,0,0,10.363,64H3.677A3.063,3.063,0,0,0,.613,67.064v1.379A1.639,1.639,0,0,0,0,69.719v.449a.366.366,0,0,0,.368.368,1.471,1.471,0,0,0,1.471-1.471v-2a1.845,1.845,0,0,1,.779-1.5,2.456,2.456,0,0,0-.166.891ZM14.3,70.945a.409.409,0,1,1,.409.409A.409.409,0,0,1,14.3,70.945ZM4.254,66.62a.578.578,0,0,1,.409-.986H9.227a.578.578,0,0,1,.409.986l-.6.6a2.959,2.959,0,0,1-4.185,0l-.6-.6Z",
    transform: "translate(0 -64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCow);
export default __webpack_public_path__ + "static/media/cow.931d208080a61b6ac78bb4a6bd4cc487.svg";
export { ForwardRef as ReactComponent };